import React, { Component } from 'react';
import i18n from 'i18n-react';
import renderHTML from 'react-render-html';
import { storageKeys } from 'settings';
import { APIHandler, DataHandler, StorageHandler, ContentHeader, BackButton } from 'C4';

const parseMessageDates = (messages) => {
  const validTypes = ['second', 'minute', 'day', 'month', 'year'];
  const [{ date }] = messages;
  if (date) {
    const newMessages = messages;
    return newMessages.map((message) => {
      const newMessage = message;
      const [number] = message.date.match(new RegExp('([0-9]*)', 'g'));
      const [type] = message.date.match(new RegExp('(seconds?|minutes?|hours?|days?|months?|years?)', 'g'));
      if (validTypes.some(t => t.startsWith(type))) {
        newMessage.date = i18n.translate(`messageCenter.${type}Ago`, { number });
      }
      return newMessage;
    });
  }
  return messages;
};

const currentDateFormat = (date) => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
};

export default class MessageCenter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      messages: [],
      activeMessage: {},
    };
  }

  componentWillMount() {
    StorageHandler.save(storageKeys.lastCheckedMessage, currentDateFormat(new Date()));
    DataHandler.requestWithId(APIHandler.getMessage)
      .then((res) => {
        this.setState({
          messages: res,
          activeMessage: Object.values(res)[0],
        });
      });
  }

  setActive(activeMessage) {
    this.setState({ activeMessage });
  }

  text(currentMessage, strip) {
    let { message } = this.state.activeMessage;
    if (currentMessage) {
      message = currentMessage;
    }

    const indices = [
      message.indexOf('.'),
      message.indexOf('!'),
      message.indexOf('?'),
    ];
    indices.forEach((index, i) => {
      if (index === -1) {
        indices[i] = Infinity;
      }
    });
    console.log(message.split('.')[0]);
    if (strip) {
      return message;
    }
    message = message.replace(/<\/?[^>]+(>|$)/g, '');
    return message.split('.')[0];
  }

  content(currentMessage) {
    const { activeMessage } = this.state;
    let { message } = activeMessage;
    if (currentMessage) {
      message = currentMessage;
    }

    return message;
  }

  render() {
    const { messages, activeMessage } = this.state;

    const messageItems = Object.values(messages).map((item, i) => {
      const key = i;
      return (
        <li key={key} className={this.state.activeMessage.message === item.message ? 'active' : ''}>
          <div
            role="button"
            id={`${key}_listItem`}
            onClick={() => this.setActive(item)}
            onKeyPress={() => this.setActive(item)}
            className="message__inbox--container"
            tabIndex={-1}
          >
            <div className="message__inbox--text">
              <h6>{item.name.length > 0 ? item.name : this.text(item.message)}</h6>
              {renderHTML(this.text(item.message))}
              <p>{item.date}</p>
            </div>
          </div>
        </li>
      );
    });

    return (
      <div className="contentContainer">
        <ContentHeader header={i18n.translate('nav.messages')} />
        <div className="message__Container">
          <div className="message__Grid">
            {this.state.messages.length > 0 ?
              <div className="message__Inbox">
                <ul>
                  {messageItems}
                </ul>
              </div>
              : <p className="subtitle">{i18n.translate('general.noMessages')}</p>}
            {activeMessage !== undefined && this.state.messages.length > 0 &&
              <div className="message__Content">
                {Object.keys(activeMessage).length > 0 &&
                  <div>
                    {(activeMessage.img !== '') &&
                      <a
                        data-fancybox={activeMessage.img}
                        data-src={activeMessage.img}
                        href={activeMessage.img}
                        key={activeMessage.img}
                      >
                        <img
                          src={activeMessage.img}
                          alt="display"
                        />
                      </a>
                    }
                    <p>{renderHTML(this.text(null, true))}</p>
                  </div>}
              </div>}
          </div>
        </div>
      </div>
    );
  }
}
